import React from 'react';
import { useAPIContext } from '../../utilities/Contexts/DCGAutomationPagesContextProvider';

// A reusable BackButton component
const BackButton = ({ label = 'Go Back', style }) => {
    const { goToPrevPage } = useAPIContext();
    return (
        <button className="pl-0" onClick={goToPrevPage} style={{ ...defaultStyle, ...style }}>
            {"< " + label}
        </button>
    );
};

// Default styling for the button (can be overridden via props)
const defaultStyle = {
    backgroundColor: 'transparent',
    color: 'white',
    padding: '10px 20px',
    fontSize: '16px',
    borderRadius: '5px',
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
};

export default BackButton;
